import {Link} from "react-router-dom";

const BackButton = ({src}) => {
    return <div className={"flex items-end"}>
        <Link to={src}>
            <p className="bg-gray2 p-2 border rounded-2xl text-white">
                <img src="/icons/back.png" className="inline me-3 w-[15px] h-[15px] transform scale-x-[-1]"/>
                بازگشت
            </p></Link>
    </div>
}

export default BackButton

